<template>
  <div
    class="flex flex-wrap gap-2 py-4 md:py-0 w-full justify-center max-h-62 overflow-y-auto md:max-h-none"
  >
    <BaseButton
      v-for="venue in filteredvenues"
      @click="() => handleClick(venue.name)"
      :key="venue.id"
      color="muted"
      class="px-3 py-1 max-w-full min-w-0"
      :class="[
        {
          '!border-primary': router.currentRoute.value.query.location === venue.name,
        },
      ]"
      ><span class="block max-w-[400px] overflow-hidden text-ellipsis whitespace-nowrap">{{ venue.name }}</span></BaseButton
    >
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import { useGeneralStore } from '@/stores/general';
  const generalStore = useGeneralStore();

  // Get venues from the general store
  const venues = computed(() => generalStore.venues());
  const events = computed(() => generalStore.events());


  // Compute a list of venue objects, filtering out duplicates and sorting alphabetically by name
  const filteredvenues = computed(() => {
    const venuesWithEvents = venues.value.filter(venue =>
      events.value.some(event => event.venue === venue.id)
    );

    // Filter out duplicate names and sort alphabetically
    const uniqueVenues = Array.from(
      new Map(venuesWithEvents.map(venue => [venue.name, venue])).values()
    );

    return uniqueVenues.sort((a, b) => a.name.localeCompare(b.name));
  });

  const router = useRouter();
  const emit = defineEmits(['onChange']);

  const handleClick = (_location: string) => {
    const currentQuery = { ...router.currentRoute.value.query };
    const newQuery = { location: undefined as string | undefined };
    if (currentQuery.location !== _location) {
      newQuery.location = _location;
    }
    router.push({
      path: '/',
      query: newQuery,
    });

    emit('onChange');
  };
</script>
